import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { EntrySmsTaskAuditFailureActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function EntrySmsTaskAuditFailure({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as EntrySmsTaskAuditFailureActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》短信模板审核失败</ItemWrapper>
}
